<template>
    <app-layout :title="'Order history for ' + $page.props.tenant.name">
        <template v-slot:header>
            <div class="flex justify-between">
                <h2 class="font-semibold text-xl text-gray-800 dark:text-gray-200 leading-tight">
                    Order History
                </h2>
            </div>
        </template>
        <div class="w-full overflow-hidden rounded-lg shadow">
            <table-layout>
                <template v-slot:theadRow>
                    <th class="px-4 py-3">Date</th>
                    <th class="px-4 py-3">Order</th>
                    <th class="px-4 py-3">Survey</th>
                    <th class="px-4 py-3">Respondent slots</th>
                    <th class="px-4 py-3">Amount</th>
                    <th class="px-4 py-3">Status</th>
                </template>
                <template v-slot:tbody v-if="paginatedOrders.data.length">
                    <tr v-for="order in paginatedOrders.data" class="text-gray-700 dark:text-gray-400">
                        <td class="px-4 py-3">
                            <div class="flex items-center text-sm">
                                <div>
                                    {{ moment(order.created_at).format("DD-MM-YYYY HH:mm") }}
                                </div>
                            </div>
                        </td>
                        <td class="px-4 py-3">
                            Order #{{ order.id }}
                        </td>
                        <td class="px-4 py-3">
                            <div class="flex items-center text-sm">
                                <div>
                                    <p class="font-semibold">{{ order.survey.name }}</p>
                                    <p class="text-xs text-gray-600 dark:text-gray-400">

                                    </p>
                                    <p v-if="!tenant" class="text-xs text-gray-600 dark:text-gray-400">
                                        {{ order.tenant ? order.tenant.name : '' }}
                                    </p>
                                </div>
                            </div>
                        </td>
                        <td class="px-4 py-3">
                            <div class="flex items-center text-sm">
                                <div>
                                    {{ order.respondent_slots }}
                                </div>
                            </div>
                        </td>
                        <td class="px-4 py-3 text-xs ">
                            <div class="flex items-center text-sm">
                                <div>
                                    &pound; {{ (order.total_price/100).toFixed(2) }}
                                </div>
                            </div>
                        </td>
                        <td class="px-4 py-3 text-xs ">
                            <div class="flex items-center">
                                <pill :type="pillColorsByStatus[order.status]">
                                    {{ order.current_status }}
                                </pill>
                            </div>
                        </td>
                    </tr>
                </template>
                <template v-slot:tbody v-else>
                    <tr class="text-center text-gray-700 dark:text-gray-400">
                        <td colspan="5">
                            No orders
                        </td>
                    </tr>

                </template>
            </table-layout>
            <table-pagination :pagination-object="paginatedOrders"/>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
import Pill from "@/Jetstream/Pill";
import TableLayout from "@/Jetstream/TableLayout";
import TablePagination from "@/Jetstream/TablePagination";

export default {
    name: "Index",
    components: {
        Pill,
        TableLayout,
        TablePagination,
        AppLayout
    },
    props: {
        paginatedOrders: {
            type: Array,
            required: true
        }
    },
    setup() {
        const pillColorsByStatus = [
            'initiated',
            'success',
        ];

        return {
            pillColorsByStatus
        }
    }
}
</script>

<style scoped>

</style>
